const Filters = require('./Filters.js');
const generalEvents = require('../events/general-events.js');
const InfinityScroll = require('../app/approvals/infinityScroll');
const _ = require('lodash');

const Approvals = (function() {
  const container = $('#approvals-container');
  const filtersContainer = $('#approvals-filters');
  Approvals.URL = /^\/aprovacoes(\/\d+)?/;

  function Approvals() {
    const _this = this;
    const filters = new Filters(route('app.aprovacoes.filtrar'), filtersContainer);

    nifty.body.overlay({fixed: true});
    init.call(this)

    filters.before = function() {
      nifty.body.overlay('show');
    };

    filters.after = function(html) {
      _this.resetDataView(html)
    };
  }

  Approvals.prototype.resetDataView = function(html) {
    const _this = this;
    if (html) {
      container.html(html);
      init.call(this);
      InfinityScroll.applySortByListeners();
      return this;
    }

    container.load(Approvals.URL, function() {
      init.call(_this);
    });

    return this;
  };

  const init = function() {
    generalEvents();
    nifty.body.overlay('hide');
    container
      .find('[data-target="#modal-despesa"], [data-target="#modal-percurso"]')
      .each(function(n, el) {
        const target = document.querySelector(el.dataset.target);
        const selectizeReport = target.querySelector('#idDespesa').selectize;
        el.addEventListener('click', function() {
          selectizeReport.setValue(el.dataset.id, true);
        }, false);
      });
  };


  return Approvals;
}());

module.exports = Approvals;
